import React, { useEffect } from "react";
import { Button } from "src/business-types/grocery/components/Button";
import print2 from "src/assets/Images/print2.png";
import print1 from "src/assets/Images/Print 1.png";
import print3 from "src/assets/Images/print3.png";
import { useConfigurationState } from "./hooks/useConfigurationState";
import { useUser } from "src/business-types/grocery/components/UserContext";

const PrintSettingsTab = () => {
  const { printType, setPrintType, orderTableType, setOrderTableType, isDualCopy, setIsDualCopy, printProductLimit, savePrintSettings } =
    useConfigurationState();
  const { user } = useUser();

  const handleSave = () => {
    savePrintSettings({
      printType,
      orderTableType,
      isDualCopy,
      printProductLimit,
    });
  };

  useEffect(() => {
    if (user?.businessType !== "Grocery") {
      document.title = "PrintType› Configuration › iMetanic";
    }
  }, []);

  return (
    <div className='w-full space-y-6 mt-2 p-2 bg-white rounded-lg shadow'>
      {/* <PageTitle title='- Configuration › PrintType' /> */}
      {/* Print Type Selection */}
      <div className={`border p-6 rounded-xl shadow`}>
        <h2 className='text-lg font-semibold mb-4'>Select Print Type</h2>

        <div className='grid grid-cols-1 md:grid-cols-3 gap-6'>
          {[
            { type: "print:1", img: print1, label: "Print type: 1", disable: orderTableType === "Table Type:2", businessType: "Grocery" },
            { type: "print:2", img: print2, label: "Print type: 2" },
            { type: "print:3", img: print3, label: "Print type: 3" },
          ].map((item) => (
            <label key={item.type} className='flex flex-col items-start gap-3 cursor-pointer p-4 border rounded-lg hover:bg-gray-50 transition'>
              <div className='flex items-center gap-2'>
                <input
                  type='radio'
                  checked={printType === item.type}
                  onChange={() => setPrintType(item.type as any)}
                  disabled={item.disable || (user?.businessType === item.businessType)}
                  className='w-4 h-4'

                />
                <p className='font-medium'>{item.label}</p>
              </div>
              <img src={item.img} className='w-full h-48 object-contain border rounded' alt='' />{" "}
            </label>
          ))}
        </div>

        {/* Table Type Selection */}
        <div className='mt-6'>
          <h3 className='text-md font-semibold mb-3'>Table Type</h3>
          <div className='flex gap-6'>
            {[
              { type: "Table Type:1", value: "Table Type 1" },
              { type: "Table Type:2", value: "Table Type 2" },
            ].map((item) => (
              <label key={item.type} className='flex items-center gap-2 cursor-pointer'>
                <input type='radio' checked={orderTableType === item.type} onChange={() => setOrderTableType(item.type as any)} className='w-4 h-4' />
                <p>{item.type}</p>
              </label>
            ))}
          </div>
        </div>

        {/* Dual Copy Option */}
        <div className='mt-6 flex items-center gap-3'>
          <label className='flex items-center gap-2 cursor-pointer'>
            <input type='checkbox' checked={isDualCopy} onChange={(e) => setIsDualCopy(e.target.checked)} className='w-4 h-4' />
            <span className='font-medium'>Dual Copy</span>
          </label>
          <span className='text-sm text-gray-500'>( Each print bill, two copies)</span>
        </div>
      </div>

      {/* Save Button */}
      <div className='flex justify-center'>
        <Button label='Save Print Settings' onClick={handleSave} />
      </div>
    </div>
  );
};

export default PrintSettingsTab;
